export const TKeyConsent = {
  CONSENT_BANNER_TITLE: "CONSENT_BANNER_TITLE",
  CONSENT_BANNER_TEXT: "CONSENT_BANNER_TEXT",
  CONSENT_BANNER_LINK: "CONSENT_BANNER_LINK",
  CONSENT_ACCEPT: "CONSENT_ACCEPT",
  CONSENT_REFUSE: "CONSENT_REFUSE",
  CONSENT_SETTINGS: "CONSENT_SETTINGS",
  CONSENT_SAVE: "CONSENT_SAVE",
  CONSENT_NECESSARY_TITLE: "CONSENT_NECESSARY_TITLE",
  CONSENT_NECESSARY_TEXT: "CONSENT_NECESSARY_TEXT",
  CONSENT_ANALYTICS_TITLE: "CONSENT_ANALYTICS_TITLE",
  CONSENT_ANALYTICS_TEXT: "CONSENT_ANALYTICS_TEXT",
  CONSENT_MANAGE: "CONSENT_MANAGE",
} as const;
